import React from 'react';
import propTypes from 'prop-types';
import { Button, ButtonGroup, DrawerBody, Typography } from '@one-thd/sui-atomic-components';
import { useMessage } from '../../../hooks/useMessage';
import { useSelectedItems } from '../../../hooks/useSelectedItems';
import { MESSAGE_KEY } from '../../../utils/constants';
import { AddMultipleToCartButton } from '../../AddMultipleToCartButton/AddMultipleToCartButton';
import {
  AddMultipleToBundleButton
} from '../../AddMultipleToBundleButton/AddMultipleToBundleButton';
import { PromoDrawerHeader } from './subcomponents/PromoDrawerHeader';
import { usePromoModel } from '../../../hooks/usePromoModel';
import { useGroupedPromoModel } from '../../../hooks/useGroupedPromoModel';

const { func } = propTypes;

export const WarningDrawer = ({ onBack, onClose }) => {
  const { isBogoPair } = usePromoModel();
  const { bypassCartLogic } = useGroupedPromoModel();
  const templateTitle = useMessage(MESSAGE_KEY.title);
  const pairTitle = useMessage(MESSAGE_KEY.pairTitle);
  const title = isBogoPair ? pairTitle : templateTitle;
  const warningDrawerPrimaryMessage = useMessage(MESSAGE_KEY.warningDrawerPrimaryMessage);
  const warningDrawerSecondaryMessage = useMessage(MESSAGE_KEY.warningDrawerSecondaryMessage);
  const warningDrawerSecondaryMessageGrouped = useMessage(MESSAGE_KEY.warningDrawerSecondaryMessageGrouped);
  const warningDrawerContinueWithoutButton = useMessage(MESSAGE_KEY.warningDrawerContinueWithoutButton);
  const { selectedItemIds } = useSelectedItems();

  return (
    <>
      <PromoDrawerHeader
        onBack={onBack}
        onClose={onClose}
        title={title}
      />
      <DrawerBody>
        <div className="sui-py-8 sui-flex sui-flex-col sui-gap-8">
          <div className="sui-flex sui-flex-col sui-gap-2">
            <div className="sui-text-8xl sui-text-center">
              {warningDrawerPrimaryMessage}
            </div>
            <Typography align="center" variant="body-lg">
              {!bypassCartLogic && warningDrawerSecondaryMessage }
              {bypassCartLogic && warningDrawerSecondaryMessageGrouped}
            </Typography>
          </div>
          <ButtonGroup orientation="vertical">
            {!bypassCartLogic
              ? <AddMultipleToCartButton itemIds={selectedItemIds} onComplete={onClose} simpleATCMessage />
              : <div hidden />}
            {bypassCartLogic
              ? <AddMultipleToBundleButton itemIds={selectedItemIds} onComplete={onClose} />
              : <div hidden />}
            <Button
              fullWidth
              onClick={onClose}
              variant="secondary"
            >
              {warningDrawerContinueWithoutButton}
            </Button>
          </ButtonGroup>
        </div>
      </DrawerBody>
    </>
  );
};

WarningDrawer.displayName = 'WarningDrawer';

WarningDrawer.propTypes = {
  onBack: func.isRequired,
  onClose: func.isRequired
};
